module.exports = __webpack_public_path__ + "static/img/ready-made-reports.124a109.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/drive/ready-made-reports.png
// module id = jK9S
// module chunks = 0